import { AbstractControlDirective, NgControl } from '@angular/forms';
import { Directive, ElementRef } from '@angular/core';

import { NgrxFormControlDirective } from 'ngrx-forms';
import { Observable } from 'rxjs';

/** An interface which allows a control to work inside a `KrosFormField`. */
@Directive()
export abstract class KrosFormFieldControl<T> {
  /** The value of the control. */
  abstract value: T | null;

  /**
   * Stream that emits whenever the state of the control changes such that the parent `KrosFormField`
   * needs to run change detection.
   */
  abstract readonly stateChanges: Observable<void>;

  /**
   * Stream that emits whenever focus of the control (input, textarea) changes.
   */
  abstract readonly focusChanges: Observable<boolean>;

  /** The element ID for this control. */
  abstract readonly id: string;

  /** Gets the AbstractControlDirective for this control. */
  abstract readonly ngControl: NgControl | AbstractControlDirective | null;

  abstract readonly ngrxControl: NgrxFormControlDirective<any> | null;

  /** Whether the control is focused. */
  abstract readonly focused: boolean;

  /** Whether the control is required. */
  abstract readonly required: boolean;

  /** Whether the control is disabled. */
  abstract readonly disabled: boolean;

  /** Whether the control is in an error state. */
  abstract readonly errorState: boolean;

  /** HTML element reference. */
  abstract readonly elementRef: ElementRef;
}
